import React from 'react'
import { Redirect } from 'react-router';

export const Navbar = () => {
  return (
  <>
    <header>
      <h1 id='heading-part'>Gr1shma <span id='last-name'>Dhakal</span></h1>
    </header>
    <hr />
  </>
  )
}
